import styled, { css } from 'styled-components';
import { spacer8, spacer32, spacer48 } from 'styles/spacers';
import { fontWeights } from 'styles/variables';
import { spotifyGreen, highlightGray, white, gray } from 'styles/colors';
import { brightRed100 } from '@spotify-internal/encore-web/core';
import { Icon } from 'components/atoms/icon';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer8};
  width: 100%;
`;

export const Input = styled.input<{
  error?: boolean;
  filled?: boolean;
}>`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  height: 6.4rem; /* Fixed height for single-line input */
  padding: 0 ${spacer32};
  border-radius: ${spacer48};
  border: 1px solid transparent;
  background: ${highlightGray};
  color: ${white};
  font-size: 2.4rem;
  font-weight: ${fontWeights.extra_bold};
  line-height: 110%;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;

  ${({ error }) =>
    error &&
    css`
      border-color: ${brightRed100};
    `}

  &:focus-within {
    outline: none;
    border-color: ${({ error }) => (error ? brightRed100 : spotifyGreen)};
  }

  &::placeholder {
    color: ${gray};
  }
`;

export const Error = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacer8};
`;

export const ErrorMessage = styled.p`
  color: ${brightRed100};
  font-size: 1.4rem;
  font-weight: ${fontWeights.normal};
  line-height: 1.6rem;
`;

export const ErrorIcon = styled(Icon)`
  color: ${brightRed100};
  width: 1.6rem;
  height: 1.6rem;
  line-height: 1.6rem;

  svg,
  div {
    height: inherit;
    width: inherit;
  }
`;
